import { Image, Tooltip,
    Modal, ModalContent, ModalBody, useDisclosure } from "@nextui-org/react";
import React, {useEffect, useState} from "react";
import logo from '../../public/assets/images/logo-member-page.png';
import NextImage from "next/image";
import Head from "next/head";

var _ = require('lodash');

/**
 * 
 * @param {*} params 
 * @returns 
 */
function StaffBlock({params, actions}) {
    let block = <></>;

    if (params?.information.photoUrl) {
        let imgClass= `${params.image.height} ${params.image.width} ${params.isBlur ? 'blur-sm' : ''}`;
        let positionData = `absolute ${params.position.left ? params.position.left : params.position.right} ${params.position.top}`;

        let infoBlock = <>
            <div className="flex items-center py-2">
                <Image
                    src={params.information.photoUrl}
                    className="object-cover rounded-xl" width={130}
                    alt={`${params.information.christianName} ${params.information.fullName}`} 
                />

                <div className="text-center text-primary px-3">
                    <strong>
                        <p>{params.information.christianName}</p>
                        <p>{params.information.fullName}</p>
                    </strong>
                    <p className="pb-2">{params.information.profession}</p>
                    <hr className="w-3/4 m-auto border-secondary"/>
                    <p className="pt-2">{params.information.dioceseName}</p>
                </div>
            </div>
        </>

        block = <>
            <Tooltip
                closeDelay={0}
                onOpenChange={(open) => actions.setIsBlur(open)}
                content={infoBlock} offset={-135}
            >
                <div className={positionData}>
                    <Image
                        isZoomed className={imgClass}
                        src={params.information.photoUrl} alt="Tông Đồ IT"
                    />
                </div>
            </Tooltip>
        </>
    }

    return block;
}

function StaffBlockMobile({params, actions}) {
    let block = <></>;

    if (params.information?.photoUrl) {
        let classCustom = `m-auto ${params.isClergy ? 'w-[101px] h-[101px]' : 'w-[89px] h-[89px]'}`;

        block = <>
            <NextImage
                onClick={() => {
                    actions.setSsModalPatron(false);
                    actions.setCurrentMember(params.information);
                    actions.onOpen();
                }}
                height={100} width={100} className={classCustom} alt="Tông Đồ IT" src={params.information.photoUrl}
            />
        </>
    }

    return block;
}

export default function MembersDetail() {
    const [staffsDetail, setStaffsDetail] = useState([]);
    const [clergiesDetail, setClergiesDetail] = useState([]);
    const [isModalPatron, setSsModalPatron] = useState(false);
    const [isBlur, setIsBlur] = useState(false);
    const [currentMember, setCurrentMember] = useState(null);
    const {isOpen, onOpen, onClose} = useDisclosure();

    const fetchData = async () => {
        fetch('/api/members')
        .then((res) => res.json())
        .then((data) => {
            if (data.total > 0) {
                setStaffsDetail(data.values.staffs)
                setClergiesDetail(data.values.clergies)
            }
        })
    };

    useEffect(() => {
        fetchData();
    }, []);

    let logoPatron = <>
        <div className="text-wrap p-5 leading-5">
            <p>
                <span className="text-primary font-bold">- Câu Lời Chúa nguồn mạch: </span>
                &quot;Ông hãy đi, và cũng hãy làm như vậy&quot; <i>(Lc 10: 37)</i>. Thiên Chúa đã không ở trên trời cao mà cứu độ con người, nhưng Ngài đã ra đi khỏi trời cao mà xuống trần gian trở thành người thân cận với con người. Qua đó, Ngài mang đến cho con người một thông điệp là: Tình yêu. Là người truyền thông, chúng ta cũng &quot;hãy đi và cũng hãy làm như vậy&quot;.
            </p>
            <p>
                <span className="text-primary font-bold">- Slogan: </span>&quot;Đi, đi, đi mãi, đi quyết liệt, đi không nhượng bộ, cũng như không ai đi với người đi lui&quot; <i>(ĐHV 12)</i>
            </p>
            <p>
                <span className="text-primary font-bold">- Mục tiêu: </span>&quot;Mục tiêu của chúng ta phải là vô hạn, chứ không là điều hữu hạn&quot; <i>(Chân phước Carlo Acutis)</i>
            </p>
            <p>
                <span className="text-primary font-bold">- Tầm nhìn: </span>CLICK & GO
            </p>
            <p>
                <span className="text-primary font-bold">- Sứ mạng: </span>Làm việc thiện chưa phải là tông đồ, làm vì xem đó là sứ mạng Chúa Kitô mới là tông đồ <i>(ĐHV 295)</i>.
            </p>

            <p className="italic text-primary text-center pt-4 sm:pt-3">
                Về đời sống thiêng liêng, mỗi thứ Bảy đầu tháng: xét mình và xưng tội, sau đó, nhóm sẽ cùng dâng lễ với quý cha tại nhà nguyện.
            </p>
        </div>
    </>

    return <>
        <Head>
            <title>GIÁO PHẬN PHÚ CƯỜNG - TÔNG ĐỒ IT</title>
            <meta name="description" content="Trang thành viên tông đồ IT của Giáo Phận Phú Cường"/>
            <meta name="keywords" content="Giáo Phận Phú Cường, giao phan phu cuong, tông đồ IT, IT, tông đò"/>
        </Head>

        {/* Desktop */}
        <div className="hidden sm:block relative bg-cathedral h-[40vw] bg-cover bg-no-repeat bg-blend-lighten bg-background/80 dark:bg-background/20 bg-white/85">
            {/* Logo and Patron */}
            <div>
                {/* Logo */}
                
                <Tooltip
                    closeDelay={0} className="w-1/2" placement="right-start"
                    onOpenChange={(open) => setIsBlur(open)}
                    content={logoPatron} offset={-135}
                >
                    <div className="absolute left-[12.35vw] top-[3.75vw]">
                        <NextImage
                            height={1000} width={1000} className="h-[11.7vw] w-[8.15vw]" alt="Tông Đồ IT" src={logo}
                        />
                    </div>
                </Tooltip>

                {/* Patron */}
                <div className="absolute left-[2vw] top-[17vw]">
                    <p className="text-center text-[1.2vw]">
                        Thánh Bổn Mạng: Chân Phước Carlo Acutis (10/10)
                    </p>

                    <p className="text-center text-[#BA0001] text-[1.5vw] leading-9 font-bold">
                        &quot;Mục tiêu của chúng ta phải là Vô hạn,
                        <br/>
                        chứ không là điều hữu hạn&quot;
                        <br/>
                        <span className="text-[1.2vw] font-normal">- Chân phước Carlo Acutis -</span>
                    </p>
                </div>
            </div>

            {clergiesDetail.length > 0 && staffsDetail.length > 0 && <>
                {/* Members */}
                <div>
                    {/* Start Line 1 */}
                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[0],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[28.2vw]', top: 'top-[6vw]' }
                        }}
                        />

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[1],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[18.2vw]', top: 'top-[6vw]' }
                        }}
                        />

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[2],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[9.1vw]', top: 'top-[6vw]' }
                        }}
                        />
                    {/* End Line 1 */}

                    {/* Start Line 2 */}
                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[3],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[34.95vw]', top: 'top-[16.1vw]' }
                        }}
                        />

                    {/* Clergy */}
                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: clergiesDetail[0],
                            image: { height: 'h-[10vw]', width: 'w-[10vw]' },
                            position: { right: 'right-[21.45vw]', top: 'top-[14.35vw]' }
                        }}
                        />

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[4],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[11.45vw]', top: 'top-[16.1vw]' }
                        }}
                        />

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[5],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[1.45vw]', top: 'top-[16.1vw]' }
                        }}
                        />
                    
                    {/* End Line 2 */}

                    {/* Start line 3 */}

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[6],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[58.95vw]', top: 'top-[27.95vw]' }
                        }}
                        />

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[7],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[48.95vw]', top: 'top-[27.95vw]' }
                        }}
                        />

                    {/* Clergy */}
                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: clergiesDetail[1],
                            image: { height: 'h-[10vw]', width: 'w-[10vw]' },
                            position: { right: 'right-[35.45vw]', top: 'top-[26.2vw]' }
                        }}
                        />

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[8],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[25.45vw]', top: 'top-[27.95vw]' }
                        }}
                        />

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[9],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[15.45vw]', top: 'top-[27.95vw]' }
                        }}
                        />

                    <StaffBlock
                        actions={{ setIsBlur: setIsBlur }}
                        params={{
                            isBlur: isBlur,
                            information: staffsDetail[10],
                            image: { height: 'h-[6.5vw]', width: 'w-[6.5vw]' },
                            position: { right: 'right-[5.65vw]', top: 'top-[27.95vw]' }
                        }}
                        />
                    {/* End Line 3 */}
                </div>
            </>}
        </div>

        {/* Mobile */}
        <div className="block sm:hidden bg-cathedral bg-cover bg-no-repeat bg-blend-lighten bg-background/80 dark:bg-background/20 bg-white/85">
            {/* Logo */}
            <div className="pt-5">
                <NextImage className="h-[145px] w-[101px] m-auto" alt="Tông Đồ IT"
                    onClick={() => {
                        setSsModalPatron(true);
                        onOpen();
                    }}
                    height={1000} width={1000} src={logo}
                />
            </div>

            {/* Patron */}
            <div>
                <p className="p-[15px] text-center text-[14px]">
                    Thánh Bổn Mạng: Chân Phước Carlo Acutis
                    <br />
                    Mừng Kính: 10/10
                </p>

                <p className="p-[15px] text-center text-[#BA0001] text-[16px] font-bold">
                    &quot;Mục tiêu của chúng ta phải là Vô hạn,
                    <br/>
                    chứ không là điều hữu hạn&quot;
                    <br/>
                    <span className="text-[12px] font-normal">- Chân phước Carlo Acutis -</span>
                </p>
            </div>

            <div className="py-5">
                {/* Clergies */}
                <div className="columns-2">
                    {clergiesDetail.length > 0 && clergiesDetail.map(function (currentClergy) {
                        return <>
                            <StaffBlockMobile
                                actions={{
                                    onOpen: onOpen,
                                    setSsModalPatron: setSsModalPatron,
                                    setCurrentMember: setCurrentMember
                                }}
                                params={{
                                    isClergy: true,
                                    information: currentClergy,
                                }}
                            />
                        </>
                    })}
                </div>

                {/* Staffs */}
                <div className="columns-3 py-[7px]">
                    {_.slice(staffsDetail, 0, 3).map((currentStaff) => {
                        return <>
                            <StaffBlockMobile
                                actions={{
                                    onOpen: onOpen,
                                    setSsModalPatron: setSsModalPatron,
                                    setCurrentMember: setCurrentMember
                                }}
                                params={{
                                    isClergy: false,
                                    information: currentStaff,
                                }}
                            />
                        </>
                    })}
                </div>

                <div className="columns-3 py-[7px]">
                    {_.slice(staffsDetail, 3, 6).map((currentStaff) => {
                        return <>
                            <StaffBlockMobile
                                actions={{
                                    onOpen: onOpen,
                                    setSsModalPatron: setSsModalPatron,
                                    setCurrentMember: setCurrentMember
                                }}
                                params={{
                                    isClergy: false,
                                    information: currentStaff,
                                }}
                            />
                        </>
                    })}
                </div>

                <div className="columns-3 py-[7px]">
                    {_.slice(staffsDetail, 6, 9).map((currentStaff) => {
                        return <>
                            <StaffBlockMobile
                                actions={{
                                    onOpen: onOpen,
                                    setSsModalPatron: setSsModalPatron,
                                    setCurrentMember: setCurrentMember
                                }}
                                params={{
                                    isClergy: false,
                                    information: currentStaff,
                                }}
                            />
                        </>
                    })}
                </div>

                <div className="columns-2 py-[7px]">
                    {_.slice(staffsDetail, 9, 11).map((currentStaff) => {
                        return <>
                            <StaffBlockMobile
                                actions={{
                                    onOpen: onOpen,
                                    setSsModalPatron: setSsModalPatron,
                                    setCurrentMember: setCurrentMember
                                }}
                                params={{
                                    isClergy: false,
                                    information: currentStaff,
                                }}
                            />
                        </>
                    })}
                </div>
            </div>

            <Modal 
                size='sm'
                isOpen={isOpen}
                onClose={onClose}
                backdrop='blur'
                placement='center'
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalBody className={`mx-auto py-5 px-0 ${isModalPatron ? 'text-left' : 'text-center'}`}>
                                {!isModalPatron && <>
                                    <div className="flex justify-center">
                                        <Image
                                            src={currentMember.photoUrl}
                                            alt={currentMember.fullName} width={130}
                                        />
                                    </div>

                                    <div className="text-primary">
                                        <strong>
                                            <p>{currentMember.christianName}</p>
                                            <p>{currentMember.fullName}</p>
                                        </strong>
                                        <p className="pb-2">{currentMember.profession}</p>
                                        <hr className="w-3/4 m-auto border-secondary"/>
                                        <p className="pt-2">{currentMember.dioceseName}</p>
                                    </div>
                                </>}

                                { isModalPatron && <> {logoPatron} </> }
                            </ModalBody>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </div>
    </>
}
